export let SubmissionAssetTypes;

(function (SubmissionAssetTypes) {
  SubmissionAssetTypes["FILE_ID"] = "FILE_ID";
  SubmissionAssetTypes["SUBMISSION_URL"] = "SUBMISSION_URL";
})(SubmissionAssetTypes || (SubmissionAssetTypes = {}));